import cn from 'classnames/bind';

export enum SpinnerSize {
    TINY = 'tiny',
    XSmall = 'x-small',
    SMALL = 'small',
    MEDIUM = 'medium',
    DEFAULT = 'default',
    BIG = 'big',
    ExtraBig = 'extra-big',
}

export enum SpinnerStrokeSize {
    LIGHT = 'light',
    MEDIUM = 'medium',
    BOLD = 'bold',
}

export enum SpinnerAnimationType {
    LINEAR = 'linear',
    DEFAULT = 'default',
}

export enum SpinnerThemes {
    DEFAULT = 'default',
}

export interface SpinnerProps {
    /** Default: SpinnerSize.DEFAULT */
    size?: SpinnerSize;
    /** Default: SpinnerStrokeSize.MEDIUM */
    strokeWidth?: SpinnerStrokeSize;
    /** Default: SpinnerAnimationType.DEFAULT */
    animationType?: SpinnerAnimationType;

    className?: string;
    spinnerClassName?: string;
    circleClassName?: string;

    theme?: SpinnerThemes;
    alignLeft?: boolean;
}

type ExternalClassNames = Pick<SpinnerProps, 'className' | 'spinnerClassName' | 'circleClassName'>;

export interface GetClassNamesParams {
    cx: typeof cn;
    size: SpinnerSize;
    strokeWidth: SpinnerStrokeSize;
    animationType: SpinnerAnimationType;
    externalClassNames: ExternalClassNames;
    theme: SpinnerThemes;
}
